import { render, staticRenderFns } from "./TgNewsDetail.vue?vue&type=template&id=2de24da3&"
import script from "./TgNewsDetail.vue?vue&type=script&lang=js&"
export * from "./TgNewsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports